import React, { useEffect, useState } from 'react'
import Pagetitle from './component/Pagetitle'
import MyAccountNav from './component/MyAccountNav'
import { useApiStore } from './hooks/ApiStoreContext';
import { Link, useNavigate } from 'react-router-dom';

import dateFormat from "dateformat";

function MyAccountOrders() {

    const navigate = useNavigate();
    const apiStore = useApiStore();
    const [tableData, setTableData] = useState([]);
    const [orderStatus, setOrderStatus] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState([]);

    useEffect(() => {
        getOrderStatusList();
        getPaymentStatusList();
        getUserOrderList();
    }, [])

    const getOrderStatusList = async () => {
        try {            
            const response = await apiStore.get("/order/GetOrderStatusList");
            console.log(response);
            setOrderStatus(response);
        } catch (error) {
            if (error.response.status !== 401) {
                console.error("There was an error fetching orders status list!", error);
            }
        }
    };

    const getPaymentStatusList = async () => {
        try {
            const response = await apiStore.get("/order/GetPaymentStatusList");
            console.log(response);
            setPaymentStatus(response);
        } catch (error) {
            if (error.response.status !== 401) {
                console.error("There was an error fetching payment status list!", error);
            }
        }
    };

    const getUserOrderList = async () => {
        try {

            let loginUserId = localStorage.getItem("geniusBabySiteUserId");
            if (!loginUserId) {
                navigate("/login");
                return;
            }
            const response = await apiStore.get(`/order/GetOrderByUserId/${loginUserId}`);
            console.log(response);
            setTableData(response);
        } catch (error) {
            if (error.response.status !== 401) {
                console.error("There was an error fetching orders for user!", error);
            }
        }
    };

    const handleViewOrderDetail = (e, id) => {
        e.preventDefault();
        navigate("/my-account-order-details/" + id);
      };


    return (
        <>
            <Pagetitle title="My Orders" />
            <section className="flat-spacing-11">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <MyAccountNav activeLink="orders" />
                        </div>
                        <div className="col-lg-9">
                            <div className="my-account-content account-order">
                                <div className="wrap-account-order">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="fw-6">Order #</th>
                                                <th className="fw-6">Order date</th>
                                                <th className="fw-6">Order status</th>
                                                <th className="fw-6">Payment Status</th>
                                                <th className="fw-6">Total</th>
                                                <th className="fw-6">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                              tableData.map((o)=>(
                                                <tr key={o.orderId} className="tf-order-item">
                                                    <td>{o.orderId}</td>
                                                    <td>{ dateFormat(o.orderDate, "dd/mm/yyyy")}</td>
                                                    <td>{orderStatus.find(os=> os.id===o.orderStatus).name}</td>
                                                    <td>{paymentStatus.find(ps=> ps.id===o.paymentStatus).name}</td>
                                                    <td>₹ {o.totalAmount}</td>
                                                    <td>

                                                    {/* <a onClick={(e)=>handleViewOrderDetail(e,o.orderId)} className="tf-btn btn-fill animate-hover-btn rounded-0 justify-content-center">
                                                            <span>View</span>
                                                        </a> */}

                                                        <a href={`/my-account-order-details/${o.orderId}`} className="tf-btn btn-fill animate-hover-btn rounded-0 justify-content-center">
                                                            <span>View</span>
                                                        </a>
                                                        {/* <Link to={`/my-account-order-details/${o.orderId}`} className="tf-btn btn-fill animate-hover-btn rounded-0 justify-content-center">
                                                            <span>View</span>
                                                        </Link> */}
                                                    </td>
                                                </tr>

                                              ))  
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default MyAccountOrders